import { useSearchParams } from 'react-router-dom';

export const useTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const get = (key: string) => searchParams.get(key) ?? undefined;

  const set = (key: string, value: string) => {
    searchParams.set(key, value);
    setSearchParams(searchParams, { replace: true });
  };

  const remove = (key: string) => {
    searchParams.delete(key);
    setSearchParams(searchParams, { replace: true });
  };

  let outlet = window.location.pathname.split('/').at(-1) ?? '';

  return { get, set, remove, outlet };
};
